import React from 'react';
import { Typography, Row, Col, Divider } from 'antd';
import {
  DollarOutlined, CoffeeOutlined, HeartOutlined, ReadOutlined, TeamOutlined,
  ExperimentOutlined, RiseOutlined, BuildOutlined, HomeOutlined, SyncOutlined,
  CloudOutlined, EnvironmentOutlined, GlobalOutlined
} from '@ant-design/icons';
import '../../../Styles/ResearchLabs.css'; // Create and import this CSS file for styling

const { Title, Paragraph } = Typography;

const researchDomains = [
  {
    domain: "Domain 1 – Geo-forensic and Geo-Health",
    description: [
      "Design process to acquire seed data from partners/collaborators.",
      "Perform data acquisition. This involves data fusion, filtering & preprocessing, data extraction, store and cleansing.",
      "Perform spatial big data processing. This step may involve processing big data with aim at extraction of relevant features. Furthermore, data may require performing partitioning.",
      "Next step involves evaluating several machine learning algorithms to get an effective learned model.",
      "The rules learned in learned model shall be represented in ontologies.",
      "SDSS for geo-forensic and geo-health shall be designed and developed based on these ontologies.",
    ],
  },
  {
    domain: "Domain 2 – Mineral Inventory Balochistan",
    description: [
      "The quantification of minerals (existing and new) is a systematic approach to accelerate the economic development of the country. Further, the human resource development associated with the development of Balochistan mineral inventory is a key factor in establishing geoscience-based technological advancement in the province. The mineral inventory will help provincial and Federal government to better understand the economic geology of the minerals in Balochistan and thereof to attract foreign investment. The use of remote sensing and GIS as a tool for mineral inventory will help to accelerate mineral exploration, evaluation, and production program. The project will revolutionize the natural resource development in the province.",
    ],
  },
];

const sdgList = [
  { label: "No Poverty", icon: DollarOutlined },
  { label: "Zero Hunger", icon: CoffeeOutlined },
  { label: "Good Health and Wellbeing", icon: HeartOutlined },
  { label: "Quality Education", icon: ReadOutlined },
  { label: "Gender Equality", icon: TeamOutlined },
  { label: "Clean Water and Sanitation", icon: ExperimentOutlined },
  { label: "Decent Work and Economic Growth", icon: RiseOutlined },
  { label: "Industry, Innovation and Infrastructure", icon: BuildOutlined },
  { label: "Sustainable Cities and Communities", icon: HomeOutlined },
  { label: "Responsible Consumption and Production", icon: SyncOutlined },
  { label: "Life Below Water", icon: CloudOutlined },
  { label: "Life On Land", icon: EnvironmentOutlined },
  { label: "Partnerships to achieve the Goal", icon: GlobalOutlined },
];

const ResearchDomainsSection = () => {
  return (
    <section className="research-domains-section sdssl-research-domains-section">
      <div className="research-domains-inner">
      <Row gutter={[72, 44]} justify="space-between">
        <Col xs={24} lg={15}>
          <Title level={2} className="research-domains-title">Research Domains</Title>
          <Divider className="ncgsa-divider" />
          {researchDomains.map((item, index) => (
            <div key={index} className="research-domain">
              <Title level={4} className="research-domain-title">{item.domain}</Title>
              {index === 0 ? (
                <ol className="research-domain-steps">
                  {item.description.map((desc) => <li key={desc}>{desc}</li>)}
                </ol>
              ) : (
                <Paragraph className="research-domain-copy">{item.description[0]}</Paragraph>
              )}
            </div>
          ))}
        </Col>
        <Col xs={24} lg={8}>
          <Title level={2} className="research-domains-title">Focus SDGs</Title>
          <Divider className="ncgsa-divider" />
          <ul className="sdg-focus-list">
            {sdgList.map(({ label, icon: Icon }) => (
              <li key={label}>
                <span className="sdg-focus-icon"><Icon /></span>
                <span>{label}</span>
              </li>
            ))}
          </ul>
        </Col>
      </Row>
      </div>
    </section>
  );
};

export default ResearchDomainsSection;
